export default {"src":"/_next/static/media/like-1.0da3455a.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};